import { motion } from 'framer-motion';
import ConnectorSelector from '../../components/ConnectorSelector';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { store } from '../../app/store';
import { setRequestedChargieId, setShowNavigator } from '../../appSlice';
import { colors } from '../../global/variables';
import { ReactComponent as CloseIcon } from '../../assets/icons/CloseIcon.svg';
import { useAppDispatch } from '../../app/hooks';
import PrimaryButton from '../../components/PrimaryButton';

const ConnectorPage: React.FC = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { desiredId, mode, connectors } = location.state;
    const [selectedConnector, setSelectedConnector] = useState<number | null>(
        null
    );
    const [buttonText, setButtonText] = useState('Start');
    const [usable, setUsable] = useState(false);
    useEffect(() => {
        store.dispatch(setShowNavigator(false));
    }, []);

    const handlePricingDetailsModalToggle = () => {
        dispatch(setRequestedChargieId(null));
        navigate('/scan', { replace: true });
    };

    function handleSubmit(): void {
        if (selectedConnector && mode && desiredId) {
            setUsable(false);
            setButtonText('Starting');
            dispatch(
                setRequestedChargieId({
                    chargieId: desiredId,
                    startType: mode,
                    connector: selectedConnector,
                })
            );
        }
    }

    useEffect(() => {
        if (selectedConnector) {
            setUsable(true);
        } else {
            setUsable(false);
        }
    }, [selectedConnector]);

    return (
        <motion.div
            className="container--full"
            style={{ paddingTop: 0, paddingBottom: 0, overflow: 'hidden' }}
            initial={
                location.state && location.state.slide === true
                    ? {
                          marginLeft: '100%',
                          width: '100%',
                          transformOrigin: 'left',
                      }
                    : {}
            }
            animate={{ marginLeft: 0 }}
        >
            <div className="content-page">
                <div className="pricing-close-container">
                    <div
                        id="guest_wrapper_modal_close"
                        className="modal__close"
                        onClick={handlePricingDetailsModalToggle}
                    >
                        <CloseIcon
                            fill={colors.inactiveWhite}
                            id="guest_wrapper_close_icon"
                        />
                    </div>
                </div>
                <div
                    style={{ padding: 20 }}
                    className="balance-selector-container"
                >
                    <div className="balance-connector-selector-title">
                        Select plug
                    </div>
                    <ConnectorSelector
                        showFull={true}
                        connectors={connectors}
                        onPress={setSelectedConnector}
                    />
                </div>
                <div className="modal__button" style={{ padding: 20 }}>
                    <PrimaryButton
                        title={buttonText}
                        onPress={handleSubmit}
                        disabled={!usable}
                        id="guest_pricing_submit_button"
                    />
                    <button
                        className="payment__back-button hidden"
                        id="guest_pricing_back_button"
                        style={{ visibility: 'hidden' }}
                        // onClick={() => goBack()}
                    >
                        Back
                    </button>
                </div>
            </div>
        </motion.div>
    );
};

export default ConnectorPage;
